import React, { useEffect, useState } from 'react'
import { apiPut } from '../ApiUrls';
import { toast } from 'react-toastify';

function UpdateAvailableModal({
    show,
    onClose,
    GetHostessProfile,
    HostessProfile
}) {
    const [MakeAvailable, setMakeAvailable] = useState(false);
    useEffect(() => {
        if (HostessProfile) {
            setMakeAvailable(HostessProfile?.MakeAvailable);
        }
    }, [HostessProfile]);

    const [IsUploading, setIsUploading] = useState(false);
    const UpdateHostess = async () => {
        if (MakeAvailable === null) {
            toast.error("MakeAvailable is required!");
            return;
        }
        try {
            setIsUploading(true)
            let data = { MakeAvailable };
            const response = await apiPut(`api/hostess/MakeAvailable`, data);
            toast.success(response?.message);
            setIsUploading(false)
            onClose();
            GetHostessProfile()
        } catch (error) {
            setIsUploading(false)
            toast.error(error?.response?.data?.message);
            console.log(error);
        }
    };

    if (!show) return null;
    return (
        <div className="modal-backdrop">
            <div className="modal-content">
                <h2>Update Available</h2>
                <br />
                <div className="about-input-div">
                    <div className="about-input">
                        <label>Available</label>
                        <select
                            value={MakeAvailable}
                            onChange={(e) => setMakeAvailable(e.target.value)}
                        >
                            <option value={true}>Available</option>
                            <option value={false}>UnAvailable</option>
                        </select>
                    </div>
                </div>
                <div className='center' style={{ gap: 20 }}>
                    <button onClick={UpdateHostess} disabled={IsUploading}>
                        {IsUploading ? 'Uploading...' : 'Update'}
                    </button>
                    <button onClick={() => { onClose() }}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default UpdateAvailableModal